import React, { useState, useEffect } from "react";
import "./StyleState.css";

const StyleState = ({
  selectedElement,
  updateElementState,
  setSelectedElement,
  classNames,
  setClassNames,
}) => {
  const [selectedState, setSelectedState] = useState("default");

  useEffect(() => {
    if (selectedElement && selectedElement.id) {
      // Get current state from selected element
      const elementState = selectedElement.currentState || "default";
      setSelectedState(elementState);

      // Get base classes
      const baseClasses = (selectedElement.className || "")
        .split(" ")
        .filter(Boolean);

      // Update class names based on current state and number of classes
      if (elementState === "default") {
        setClassNames(baseClasses);
      } else {
        if (baseClasses.length === 1) {
          // Single class case
          const stateClasses = baseClasses.map((c) => `${c}--${elementState}`);
          setClassNames(stateClasses);
        } else {
          // Multiple classes case
          const combinedBaseClass = baseClasses.join("+");
          const stateClass = `${combinedBaseClass}--${elementState}`;
          setClassNames([stateClass]);
        }
      }
    }
  }, [selectedElement]); // Only run when selectedElement changes

  const handleStateChange = (newState) => {
    if (selectedState === newState || !selectedElement || !selectedElement.id)
      return;

    const baseClasses = (selectedElement.className || "")
      .split(" ")
      .filter(Boolean);

    if (newState === "default") {
      if (selectedState !== "default") {
        updateElementState(selectedElement.id, selectedState, false);
      }
      setClassNames(baseClasses);
    } else {
      updateElementState(selectedElement.id, newState, true);

      if (baseClasses.length === 1) {
        // Single class case
        const stateClasses = baseClasses.map((c) => `${c}--${newState}`);
        setClassNames(stateClasses);
      } else {
        // Multiple classes case
        const combinedBaseClass = baseClasses.join("+");
        const stateClass = `${combinedBaseClass}--${newState}`;
        setClassNames([stateClass]);
      }
    }

    setSelectedState(newState);
  };

  // Don't render if we don't have a valid selected element
  if (!selectedElement || !selectedElement.id) return null;

  return (
    <div className="state-selector-dropdown">
      <div 
        className="section-header state-section-header" 
        data-state={selectedState}
      >
        <h4 className="section-title-basic-properties">Switch State</h4>
        <select
          value={selectedState}
          onChange={(e) => handleStateChange(e.target.value)}
          style={{
            backgroundColor:
              selectedState === "default"
                ? "#2a2a2a"
                : selectedState === "hover"
                ? "#6a00e0"
                : selectedState === "pressed"
                ? "#972b2b"
                : "#57972b",
            color: "#fff",
          }}
        >
          <option value="default">Default</option>
          <option value="hover">Hover</option>
          <option value="pressed">Pressed</option>
          <option value="focused">Focus</option>
        </select>
      </div>
    </div>
  );
};

export default StyleState;
